var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_vm._l((_vm.buttons),function(button){return [(button.display)?_c('kdw-btn',{key:button.id,staticClass:"ma-2",attrs:{"color":_vm.color,"dark":"","min-width":"70","disabled":button.disabled}},[_c('v-icon',[_vm._v(_vm._s(button.id))])],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }